/**
 * FeedSkeleton — card-shaped loading skeletons for the feed grid (redesign 1j).
 * Eyebrow, 2-line title, 3-line body, footer — never a spinner over a blank page.
 */
import React from "react";

const Bar = ({ w, h = "h-2.5", dm }) => (
  <div className={`${h} ${w} rounded-full ${dm ? "bg-white/8" : "bg-[#e8ecee]"}`} />
);

const SkeletonCard = ({ dm }) => (
  <div
    className={`rounded-2xl p-5 animate-pulse ${dm ? "bg-[#1a2122]" : "bg-white"}`}
    style={{ minHeight: 200, boxShadow: "0 0 0 1px rgba(186,201,204,0.12)" }}
  >
    <div className="flex items-center justify-between mb-4">
      <Bar w="w-24" h="h-2" dm={dm} />
      <Bar w="w-12" h="h-2" dm={dm} />
    </div>
    <div className="space-y-2 mb-4">
      <Bar w="w-full" h="h-3.5" dm={dm} />
      <Bar w="w-3/4" h="h-3.5" dm={dm} />
    </div>
    <div className="space-y-2 mb-5">
      <Bar w="w-full" dm={dm} />
      <Bar w="w-full" dm={dm} />
      <Bar w="w-2/3" dm={dm} />
    </div>
    <div className="flex items-center justify-between">
      <Bar w="w-20" h="h-2" dm={dm} />
      <Bar w="w-14" h="h-2" dm={dm} />
    </div>
  </div>
);

export default function FeedSkeleton({ dm = false, count = 9 }) {
  return (
    <div data-testid="feed-skeleton-grid" className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} dm={dm} />
      ))}
    </div>
  );
}
